import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, ShieldCheckIcon, TrendingUpIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToForm = () => {
    document.getElementById('qualify-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[85vh] flex items-center justify-center px-4 py-12 overflow-hidden bg-black" data-id="element-43">
      {/* Radial gold gradient glow */}
      <div className="absolute inset-0 bg-gradient-radial from-gold-primary/10 via-transparent to-transparent opacity-30" data-id="element-44" />

      <div className="relative z-10 max-w-4xl mx-auto text-center mt-8" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex flex-col items-center gap-1.5 mb-6" data-id="element-46">
          <span className="inline-flex items-center gap-2 bg-gold-primary/10 text-gold-primary border border-gold-primary/30 px-4 py-1.5 rounded-full text-sm font-semibold" data-id="element-47">
            <span data-id="element-48">⚡</span> Limited Funding Available — Apply Today
          </span>
          <span className="text-xs text-gray-400 font-medium tracking-wide" data-id="element-49">
            🇪🇸 Hablamos Español
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-serif text-5xl md:text-7xl lg:text-8xl mb-4 leading-tight" data-id="element-50">
          Get up to $250K in 24–48 hours
          <br data-id="element-51" />
          <span className="text-gold-primary" data-id="element-52">(Even if banks said no)</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto font-sans font-medium" data-id="element-53">
          Fast, flexible funding. Simple process. No hard credit pull.
        </motion.p>

        <motion.button initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0,
        boxShadow: ['0 0 20px rgba(240,185,11,0.3)', '0 0 40px rgba(240,185,11,0.6)', '0 0 20px rgba(240,185,11,0.3)']
      }} transition={{
        duration: 0.6,
        delay: 0.4,
        boxShadow: {
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }
      }} onClick={scrollToForm} className="bg-gold-primary text-black font-bold text-xl md:text-2xl px-12 md:px-16 py-5 md:py-6 rounded-lg hover:bg-gold-accent transition-all duration-300 mb-3" data-id="element-54">
          See Your Funding Options in 60 Seconds →
        </motion.button>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-sm text-gray-400 mb-10 font-medium" data-id="element-55">
          60 seconds to apply • No credit impact • Free to check
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12" data-id="element-56">
          <div className="flex items-center gap-3" data-id="element-57">
            <ClockIcon className="w-6 h-6 text-gold-primary" data-id="element-58" />
            <span className="text-sm md:text-base font-medium" data-id="element-59">
              24-48hr Approvals
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-60">
            <ShieldCheckIcon className="w-6 h-6 text-gold-primary" data-id="element-61" />
            <span className="text-sm md:text-base font-medium" data-id="element-62">
              No Hard Credit Pull
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-63">
            <TrendingUpIcon className="w-6 h-6 text-gold-primary" data-id="element-64" />
            <span className="text-sm md:text-base font-medium" data-id="element-65">
              Multiple Funding Options
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="flex items-center justify-center gap-2 mt-12 text-gray-400" data-id="element-66">
          <ShieldCheckIcon className="w-4 h-4 text-gold-primary" data-id="element-67" />
          <span className="text-sm font-medium tracking-wide" data-id="element-68">
            Trusted by business owners across the U.S.
          </span>
        </motion.div>
      </div>
    </section>;
}